export default __webpack_public_path__ + "assets/8b30b3ea87369cd88d7d8aa5ea052dff.png";